import React from 'react';

import data from '@emoji-mart/data';
import {Picker} from 'emoji-mart';

const EmojiPicker = (props) => {
  const ref = React.useRef();

  React.useEffect(() => {
    new Picker({...props, data, ref});
  }, []);

  return <div ref={ref} style={{minWidth: '352px', minHeight: '230px'}}/>;
};

export default React.memo(EmojiPicker);
